import { AgentType } from "@/types/base";

// Shared validation function for voicemail email requirement
export const voicemailEmailValidation = (data: {
  type: AgentType;
  voicemailEmail?: string | null;
}) => {
  // If agent type is voicemail, voicemailEmail is required
  if (data.type === AgentType.VOICEMAIL) {
    return data.voicemailEmail && data.voicemailEmail.trim().length > 0;
  }
  return true;
};
